import { render, staticRenderFns } from "./CallRecorderGroupsManager.vue?vue&type=template&id=dfc50fa0&"
import script from "./CallRecorderGroupsManager.vue?vue&type=script&lang=js&"
export * from "./CallRecorderGroupsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports